import { Injectable, OnDestroy, inject } from '@angular/core';
import { Colors } from '@app/core/services/api/API.service';
import { BehaviorSubject } from 'rxjs';
import { sortJSON } from '../../util.service';
import { take } from 'rxjs/operators';
import { ColorsService as ColorsApiService } from '@app/core/api/services';

@Injectable({
    providedIn: 'root'
})
export class ColorsService implements OnDestroy {
    private _colors$ = new BehaviorSubject<Colors[]>([]);
    private _loading$ = new BehaviorSubject<boolean>(true);
    private colors: Colors[] = [];
    private subscriptions: any[] = [];
    private _colorsApiService = inject(ColorsApiService);

    private _isLoading = false;

    constructor() {}

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    get colors$() {
        return this._colors$.asObservable();
    }

    get loading$() {
        return this._loading$.asObservable();
    }

    getColorsSnapshot(): Colors[] {
        return this._colors$.getValue() ?? [];
    }

    wasLoaded(): boolean {
        return !this._isLoading && this._loading$.getValue() === false;
    }

    async listColors() {
        if (this._isLoading) {
            await this.colors$.pipe(take(1)).toPromise();
            return;
        }

        const existingColors = this._colors$.getValue();
        if (existingColors && existingColors.length > 0) {
            return;
        }

        this._isLoading = true;
        try {
            this._loading$.next(true);
            this.colors = await this.listColorsBD();
        } catch (err) {
            this.colors = [];
        } finally {
            this._colors$.next(this.colors);
            this._loading$.next(false);
            this._isLoading = false;
        }
    }

    async findColorById(id: string): Promise<Colors | undefined> {
        try {
            const colors = await this.colors$.pipe(take(1)).toPromise();
            return colors.find(color => color.id === id);
        } catch (error) {
            console.error('Error finding color:', error);
            return undefined;
        }
    }

    private async listColorsBD(): Promise<Colors[]> {
        const items = await this._colorsApiService.listColorsByPosition();
        return sortJSON(items, 'position', 'asc');
    }
}
